<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <fm-create-or-update v-model="fm" :errors="errors"></fm-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    :add-callback="createNew"></v-table>
    </b-card>
</template>


<script>
import { BCard } from 'bootstrap-vue';
import FMCreateOrUpdate from './components/FMCreateOrUpdate.vue';

export default { 
    components:{
        BCard,
        'fm-create-or-update':FMCreateOrUpdate
    },
    data(){
        return {
            editing:false,
            loading:false,
            errors:{},
            fm:{
                EmployeeId:null,
                Date:null,
                StartTime:null,
                EndTime:null,
                WorkTime:null,
                FoodCount:0,
            },
        }
    },
    methods:{
        clearForm(){
            this.editing = false
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        createOrUpdate(){}
    }
}
</script>